import { Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import forgot from "../../assets/images/icon_login/forgot-password.svg";
import TabsMobile from "../__template/TabsMobileComponent";
import eye from "../../assets/images/icon_login/eye.svg";
import eyeOff from "../../assets/images/icon_login/eye-off.svg";
import { forgotPassword } from "../../core/service/api_profile";
import { toast } from "react-toastify";

const ComponentForgotPasswordCreate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location: any = useLocation();
  const [inputActive, setInputActive] = useState(true);

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [data, setData] = useState<any>({});

  const [typeOldPassword, setTypeOldPassword] = useState("password");
  const [typeNewPassword, setTypeNewPassword] = useState("password");
  const [typeNew2Password, setTypeNew2Password] = useState("password");
  const funTypePassword = async (type: string) => {
    switch (type) {
      case "old":
        if (typeOldPassword == "text") {
          setTypeOldPassword("password");
        } else {
          setTypeOldPassword("text");
        }
        break;
      case "new":
        if (typeNewPassword == "text") {
          setTypeNewPassword("password");
        } else {
          setTypeNewPassword("text");
        }
        break;
      default:
        if (typeNew2Password == "text") {
          setTypeNew2Password("password");
        } else {
          setTypeNew2Password("text");
        }
        break;
    }
  };

  const funForgotPassword = async () => {
    const regexPassword = /^(?=.*[a-z])(?=.*\d)[a-zA-Z\d]{6,}$/;
    console.log(newPassword.match(regexPassword));

    if (!newPassword.match(regexPassword)) {
      toast.warning(t("LOGIN.passContain"));
    } else if (!newPassword2.match(regexPassword)) {
      toast.warning(t("LOGIN.passCharacter"));
    }

    if (newPassword == "" || newPassword2 == "")
      return toast.warning(t("FORGOT-PASSWORD-CREATE.warning1"));
    if (newPassword.length < 5 || newPassword2.length < 5)
      return toast.warning(t("FORGOT-PASSWORD-CREATE.warning1"));
    if (newPassword == newPassword2) {
      var query = {
        newPassword: newPassword,
        otp: data.otp,
        phoneEmail: data.phoneEmail,
        sendVia: data.sendVia,
        reqTime: data.reqTime,
      };
      forgotPassword(query).then((res) => {
        toast.success(t("FORGOT-PASSWORD-CREATE.success1"));
        navigate("/login", { replace: true });
      });
    } else {
      toast.warning(t("FORGOT-PASSWORD-CREATE.warning2"));
    }
  };
  useEffect(() => {
    console.log(JSON.parse(location?.state?.data));

    setData(JSON.parse(location?.state?.data));
  }, []);
  return (
    <div className="min-h-screen h-full px-10 py-7 bg-psp-primary">
      <TabsMobile
        name={`${t("FORGOT-PASSWORD.title")}`}
        backUrl={"login"}
      ></TabsMobile>
      <section className="relative flex flex-col top-to-bottom">
        <h1 className="font-montserrat font-bold text-sm text-black my-4">
          {t("FORGOT-PASSWORD-CREATE.subtitle")}
        </h1>
        <div className="flex flex-col gap-2">
          <h1 className="font-montserrat text-sm text-black leading-5 font-medium pl-1 mb-0">
            {t("FORGOT-PASSWORD-CREATE.newPassword")}
          </h1>
          <div className="relative w-full flex">
            <input
              type={typeNewPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              value={newPassword}
              className="px-3 grow rounded-lg h-10 border-1 border-psp-gray border-solid"
            />
            <img
              src={typeNewPassword != "text" ? eyeOff : eye}
              className="font-bold text-black absolute z-10 top-2 right-3"
              onClick={() => funTypePassword("new")}
            />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <h1 className="font-montserrat text-sm text-black leading-5 font-medium pl-1 mb-0">
            {t("FORGOT-PASSWORD-CREATE.confirmNewPassword")}
          </h1>
          <div className="relative w-full flex">
            <input
              type={typeNew2Password}
              onChange={(e) => setNewPassword2(e.target.value)}
              value={newPassword2}
              className="px-3 grow rounded-lg h-10 border-1 border-psp-gray border-solid"
            />
            <img
              src={typeNew2Password != "text" ? eyeOff : eye}
              className="font-bold text-black absolute z-10 top-2 right-3"
              onClick={() => funTypePassword("new2")}
            />
          </div>
        </div>
        <button
          onClick={() => funForgotPassword()}
          className="mt-4 bg-psp-btn-primary text-white font-bold w-full py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active"
        >
          {t("FORGOT-PASSWORD-CREATE.confirm")}
        </button>
      </section>
      {/* <section className="flex flex-col mt-14">
          <h1 className="font-montserrat m-0 font-bold text-sm text-black text-center">
            Reset Password
          </h1>
          <p className="font-montserrat mt-2 font-medium text-xs text-black text-center">
            Kami telah mengirim 6 digit kode. Silahkan masukan untuk mereset
            passwordmu
          </p>
          <h1 className="font-montserrat m-0 font-bold text-sm text-black text-center">
            Masukkan Kode
          </h1>
          <hr />
          <h1 className="font-montserrat m-0 font-medium text-sm text-black text-center">
            Silahkan kirimkan ke whatsapp dan email yang{" "}
            <span className="text-red-600">sudah terdaftar</span>
          </h1>
          <button className="mt-2 bg-psp-btn-primary text-white font-bold w-full py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active">
            Kirim OTP
          </button>
        </section> */}
    </div>
  );
};

export default ComponentForgotPasswordCreate;
